import * as api from 'services/api';
import apiPaths from 'services/apiPaths';
import { IEditPharmacy } from 'src/shared/models/userProfile.model';

const setPharmacyToLowerCase = ({ pharmacy }) => {
  return Object.entries(pharmacy).reduce((a, [key, value]) => {
    a[key.toLowerCase()] = value;
    return a;
  }, {});
};

const getPharmacy = async (sapCustomerId: string) =>
  api
    .getDataCall({
      dataPath: `${apiPaths.PHARMACY.GET_PHARMACY}/${sapCustomerId}`,
      callConfig: {},
    })
    .then((r) => {
      if (r.data) {
        return { ...r.data, id: sapCustomerId };
      } else {
        return null;
      }
    })
    .catch((err) => {
      console.error('Could not found desired pharmacy', err);
      return null;
    });

const getUserPharmacy = async ({ user }) => {
  return await getPharmacy(user.salesforce.sapCustomerId);
};

const getPharmacies = async ({ zipCode, securedCall, idChallenge }) => {
  if (securedCall && idChallenge) {
    return api
      .getDataCall({
        dataPath: `${apiPaths.CHALLENGES.CHECKOUT_PHARMACIES}/${idChallenge}?zipcode=${zipCode}`,
        callConfig: {},
      })
      .then((r) => r.data);
  }

  return api
    .getPublicApiCombo(`${apiPaths.COMBO_IDS.PHARMACIES}&param=${zipCode}`)
    .then((r) => r.data);
};

interface IHandleFilterPharmacies {
  pharmacyList: IEditPharmacy[];
  textFilter: string;
}

const handleFilterPharmacies = ({
  pharmacyList,
  textFilter,
}: IHandleFilterPharmacies) => {
  const clonePharmacyList = [...pharmacyList];

  return clonePharmacyList.filter(
    (pharmacy) =>
      pharmacy.accountName.toLowerCase().includes(textFilter.toLowerCase()) ||
      pharmacy.street.toLowerCase().includes(textFilter.toLowerCase())
  );
};

export {
  getPharmacy,
  getPharmacies,
  setPharmacyToLowerCase,
  getUserPharmacy,
  handleFilterPharmacies,
};
